<router-outlet></router-outlet> <dntl-share-dialog></dntl-share-dialog>
